import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
import styles from "./Footer.module.css";

function Footer() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  // Logic: Check if current page is Menu or Products
  const isDisclaimerRequiredPage =
    location.pathname === "/menu" || location.pathname === "/products";

  return (
    <footer className={styles.footerSection}>
      <div className={styles.footerContent}>
        {/* --- TOP DISCLAIMER TEXT --- */}
        <div className={styles.footerTopSection}>
          {/* 1. Paragraphs 1 & 2 only appear on Menu and Products */}
          {isDisclaimerRequiredPage && (
            <>
              <p className={styles.footerTopText}>
                1. Coffee bean availability may vary based on seasonal harvest,
                regional climate conditions, and stock levels. Free standard
                delivery is available for all orders over 1,000 ETB within Addis
                Ababa city limits. International shipping rates and delivery
                times vary by location and are calculated at checkout. Please
                allow 1-2 business days for order processing.
              </p>
              <p className={styles.footerTopText}>
                2. Dukamo Coffee is dedicated to sustainable sourcing and
                ethical farming practices. All our beans are hand-picked and
                expertly roasted to ensure the highest quality. Prices are
                subject to change without notice based on market conditions. We
                reserve the right to correct any errors, inaccuracies, or
                omissions, and to change or update information at any time
                without prior notice.
              </p>
            </>
          )}

          {/* Trademark remains visible on all pages */}
          <p className={styles.footerTopText}>
            Dukamo™ and the Dukamo Logo are registered trademarks of Buncho
            Coffee Trading PLC in Ethiopia and other countries.
          </p>
        </div>

        {/* --- GRID COLUMNS --- */}
        <div className={styles.footerColumns}>
          <div className={styles.column}>
            <h3>Shop</h3>
            <Link to="/roastery">All Coffee</Link>
            <Link to="/cart">My Cart</Link>
          </div>

          <div className={styles.column}>
            <h3>Dukamo Coffee</h3>
            <Link to="/locations/mafi">Dukamo Mafi</Link>
            <Link to="/locations/bherawi">Dukamo Bherawi</Link>
            <Link to="/locations/hawassa">Dukamo Hawassa</Link>
          </div>

          <div className={styles.column}>
            <h3>Explore</h3>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/menu">Menu</Link>
          </div>

          <div className={styles.column}>
            <h3>Connect</h3>
            <div className={styles.socialRow}>
              <a
                href="https://www.instagram.com/dukamocoffee/"
                target="_blank"
                rel="noreferrer"
                className={styles.socialIcon}
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/dukamocoffee/"
                target="_blank"
                rel="noreferrer"
                className={styles.socialIcon}
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.tiktok.com/@dukamocoffee"
                target="_blank"
                rel="noreferrer"
                className={styles.socialIcon}
                aria-label="TikTok"
              >
                <FaTiktok />
              </a>
            </div>
          </div>
        </div>

        {/* --- BOTTOM BAR --- */}
        <div className={styles.footerBottom}>
          <div className={styles.legalSection}>
            <p className={styles.copyright}>
              Copyright © {currentYear} Dukamo Coffee. All rights reserved.
            </p>

            <div className={styles.legalLinks}>
              {/* 2. All legal links now appear on all pages */}
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Use</Link>
              {/* <Link to="/sales-policy">Sales and Refunds</Link> */}
              <Link to="/legal">Legal</Link>
            </div>

            <div style={{ marginTop: "5px" }}>
              <span style={{ color: "#555" }}>Powered by </span>
              <a
                href="https://hidertechnology.com"
                target="_blank"
                rel="noreferrer"
                className={styles.hiderLink}
              >
                Hider Technology
              </a>
            </div>
          </div>

          <div className={styles.country}>Ethiopia</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
